import { useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import { validateLoggedIn } from '../../redux/Authentication/actions';
import { authenticationDataSelector } from '../../redux/Authentication/selector';

function Authentication(props) {
  const { data } = props;
  const { isLoggedIn } = data;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn !== true) {
      dispatch(validateLoggedIn());
    }
  }, [dispatch, isLoggedIn]);

  return (props.children);
}

const mapStateToProps = (state) => ({
  data: authenticationDataSelector(state.authentication),
});

export default connect(mapStateToProps)(Authentication);
